import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import { ProtectedRoute } from '@/components/layout/ProtectedRoute';

const ProjectsListPage = lazy(() => import('./ProjectsListPage'));
const ProjectDetailPage = lazy(() => import('./ProjectDetailPage'));

export const projectRoutes: RouteObject[] = [
  {
    path: 'projects',
    element: (
      <ProtectedRoute action="projects:view">
        <ProjectsListPage />
      </ProtectedRoute>
    ),
  },
  {
    path: 'projects/:id',
    element: (
      <ProtectedRoute action="projects:view">
        <ProjectDetailPage />
      </ProtectedRoute>
    ),
  },
];
